import { FrontPageTranslations } from "./types";

export const enTranslations: FrontPageTranslations = {
    joinClass: "Join Class",
    reviewPreviousGames: "Review Previous Games",
};
